<div class="screen-container">
  <h1 *ngIf="isMinasidor" class="header">
    {{ "summary.minasidorHeader" | translate }}
  </h1>
  <app-card [isSummary]="true">
    <div left-content>
      <div class="content-container">
        <h1 *ngIf="!isMinasidor" class="summary-header">
          {{ "summary.header" | translate }}
        </h1>
        <app-infobox
          *ngIf="!isBigTicket"
          [title]="barometerTitle"
          [content]="barometerContent"
          [barometer]="true"
          [locale]="country"
        >
        </app-infobox>
        <div *ngIf="!isLoading; else loader" class="expansion-panels-container">
          <!-- EXTRAS -->
          <div *ngFor="let extra of flowService.flow.extra">
            <div [ngSwitch]="extra.path">
              <div *ngSwitchCase="'/turnover'">
                <h2 *ngIf="extra.blockTitle" class="block-title">
                  {{ extra.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="
                    'summary.financialInfo.estimatedTurnover' | translate
                  "
                  [panelTitle]="
                    applicationService.estimatedTurnover | myCurrency
                  "
                  [panelOpen]="panelOpenStatus.turnover"
                  (opened)="handleOpenPanel('turnover')"
                  (closed)="handleClosePanel('turnover')"
                >
                  <div content>
                    <app-turnover [isSummary]="true"></app-turnover>
                  </div>
                </app-expansion-container>
                <app-expansion-container
                  [panelHeader]="
                    'summary.financialInfo.estimatedTurnoverPrev' | translate
                  "
                  [panelTitle]="
                    applicationService.estimatedTurnoverPrev | myCurrency
                  "
                  [panelOpen]="panelOpenStatus.turnover"
                  (opened)="handleOpenPanel('turnover')"
                  (closed)="handleClosePanel('turnover')"
                  [simple]="true"
                ></app-expansion-container>
              </div>
              <div *ngSwitchCase="'/monthly-sales'">
                <h2 *ngIf="extra.blockTitle" class="block-title">
                  {{ extra.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="
                    'summary.financialInfo.monthlySales' | translate
                  "
                  [panelTitle]="
                    applicationService.estimatedMonthlySales | myCurrency
                  "
                  [panelOpen]="panelOpenStatus.monthlySales"
                  (opened)="handleOpenPanel('monthlySales')"
                  (closed)="handleClosePanel('monthlySales')"
                >
                  <div content>
                    <app-monthly-sales [isSummary]="true"></app-monthly-sales>
                  </div>
                </app-expansion-container>
              </div>
            </div>
          </div>
          <!-- END: EXTRAS-->
          <div *ngFor="let question of flowService.flow.questions">
            <div [ngSwitch]="question.path">
              <div *ngSwitchCase="'/MT940'">
                <h2 *ngIf="question.blockTitle" class="block-title">
                  {{ question.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="
                    'summary.' + question.path.slice(1) + '.panelHeader'
                      | translate
                  "
                  [panelTitle]="generalFilesPanelTitle(question.path)"
                  [panelOpen]="panelOpenStatus.mt940"
                  (opened)="handleOpenPanel('mt940')"
                  (closed)="handleClosePanel('mt940')"
                >
                  <div content>
                    <app-generic-file-upload
                      [isSummary]="true"
                      [path]="question.path"
                    ></app-generic-file-upload>
                  </div>
                </app-expansion-container>
              </div>
              <div *ngSwitchCase="'/purpose'">
                <h2 *ngIf="question.blockTitle" class="block-title">
                  {{ question.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="'summary.purposeHeader' | translate"
                  [panelTitle]="purposeTitle"
                  [panelOpen]="panelOpenStatus.purpose"
                  (opened)="handleOpenPanel('purpose')"
                  (closed)="handleClosePanel('purpose')"
                >
                  <div content>
                    <app-purpose [isSummary]="true"></app-purpose>
                  </div>
                </app-expansion-container>
              </div>
              <div *ngSwitchCase="'/guarantor'" #guarantor>
                <h2 *ngIf="question.blockTitle" class="block-title">
                  {{ question.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="'summary.guarantor.header' | translate"
                  [panelTitle]="guarantorTitle"
                  [panelOpen]="panelOpenStatus.guarantor"
                  (opened)="handleOpenPanel('guarantor')"
                  (closed)="handleClosePanel('guarantor')"
                >
                  <div content>
                    <app-guarantor [isSummary]="true"></app-guarantor>
                  </div>
                </app-expansion-container>
              </div>
              <div *ngSwitchCase="'/turnover'">
                <h2 *ngIf="question.blockTitle" class="block-title">
                  {{ question.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="
                    'summary.financialInfo.estimatedTurnover' | translate
                  "
                  [panelTitle]="
                    applicationService.estimatedTurnover | myCurrency
                  "
                  [panelOpen]="panelOpenStatus.turnover"
                  (opened)="handleOpenPanel('turnover')"
                  (closed)="handleClosePanel('turnover')"
                >
                  <div content>
                    <app-turnover [isSummary]="true"></app-turnover>
                  </div>
                </app-expansion-container>
                <app-expansion-container
                  [panelHeader]="
                    'summary.financialInfo.estimatedTurnoverPrev' | translate
                  "
                  [panelTitle]="
                    applicationService.estimatedTurnoverPrev | myCurrency
                  "
                  [panelOpen]="panelOpenStatus.turnover"
                  (opened)="handleOpenPanel('turnover')"
                  (closed)="handleClosePanel('turnover')"
                  [simple]="true"
                >
                </app-expansion-container>
              </div>
              <div *ngSwitchCase="'/monthly-sales'">
                <h2 *ngIf="question.blockTitle" class="block-title">
                  {{ question.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="
                    'summary.financialInfo.monthlySales' | translate
                  "
                  [panelTitle]="
                    applicationService.estimatedMonthlySales | myCurrency
                  "
                  [panelOpen]="panelOpenStatus.monthlySales"
                  (opened)="handleOpenPanel('monthlySales')"
                  (closed)="handleClosePanel('monthlySales')"
                >
                  <div content>
                    <app-monthly-sales [isSummary]="true"></app-monthly-sales>
                  </div>
                </app-expansion-container>
              </div>
              <div *ngSwitchCase="'/accounting-upload'">
                <h2 *ngIf="question.blockTitle" class="block-title">
                  {{ question.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="'summary.financialInfo.balance' | translate"
                  [panelTitle]="balanceTitle"
                  [panelOpen]="panelOpenStatus.accountingUpload"
                  (opened)="handleOpenPanel('accountingUpload')"
                  (closed)="handleClosePanel('accountingUpload')"
                >
                  <div content>
                    <app-accounting-upload
                      [isSummary]="true"
                    ></app-accounting-upload>
                  </div>
                </app-expansion-container>
                <app-expansion-container
                  [panelHeader]="
                    'summary.financialInfo.profitAndLoss' | translate
                  "
                  [panelTitle]="profitAndLossTitle"
                  [panelOpen]="panelOpenStatus.accountingUpload"
                  (opened)="handleOpenPanel('accountingUpload')"
                  (closed)="handleClosePanel('accountingUpload')"
                  [simple]="true"
                >
                </app-expansion-container>
              </div>
              <div *ngSwitchCase="'/account-data'">
                <h2 *ngIf="question.blockTitle" class="block-title">
                  {{ question.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="
                    'summary.financialInfo.accountData' | translate
                  "
                  [panelTitle]="accountDataTitle"
                  [panelOpen]="panelOpenStatus.accountData"
                  (opened)="handleOpenPanel('accountData')"
                  (closed)="handleClosePanel('accountData')"
                >
                  <div content>
                    <app-account-data [isSummary]="true"></app-account-data>
                  </div>
                </app-expansion-container>
              </div>
              <div *ngSwitchCase="'/real-estate'">
                <h2 *ngIf="question.blockTitle" class="block-title">
                  {{ question.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="'summary.collateral.realEstate' | translate"
                  [panelTitle]="realEstateTitle"
                  [panelOpen]="panelOpenStatus.realEstate"
                  (opened)="handleOpenPanel('realEstate')"
                  (closed)="handleClosePanel('realEstate')"
                >
                  <div content>
                    <app-real-estate [isSummary]="true"></app-real-estate>
                  </div>
                </app-expansion-container>
              </div>
              <div *ngSwitchCase="'/securities'">
                <h2 *ngIf="question.blockTitle" class="block-title">
                  {{ question.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="
                    'summary.collateral.factoringLabel' | translate
                  "
                  [panelTitle]="applicationService.factoring | myCurrency"
                  [panelOpen]="panelOpenStatus.factoring"
                  (opened)="handleOpenPanel('factoring')"
                  (closed)="handleClosePanel('factoring')"
                >
                  <div content>
                    <app-securities [isSummary]="true"></app-securities>
                  </div>
                </app-expansion-container>
                <app-expansion-container
                  [panelHeader]="
                    'summary.collateral.companyMortgageLabel' | translate
                  "
                  [panelTitle]="applicationService.companyMortgage | myCurrency"
                  [panelOpen]="panelOpenStatus.factoring"
                  (opened)="handleOpenPanel('factoring')"
                  (closed)="handleClosePanel('factoring')"
                  [simple]="true"
                >
                </app-expansion-container>
              </div>
              <div *ngSwitchCase="'/other-securities'">
                <h2 *ngIf="question.blockTitle" class="block-title">
                  {{ question.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="'summary.other.otherSecurities' | translate"
                  [panelTitle]="otherSecuritiesPanelTitle"
                  [panelOpen]="panelOpenStatus.other"
                  (opened)="handleOpenPanel('other')"
                  (closed)="handleClosePanel('other')"
                >
                  <div content>
                    <app-other-securities
                      [isSummary]="true"
                    ></app-other-securities>
                  </div>
                </app-expansion-container>
              </div>

              <div *ngSwitchCase="'/iban'">
                <h2 *ngIf="question.blockTitle" class="block-title">
                  {{ question.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="'summary.iban.label' | translate"
                  [panelTitle]="applicationService.iban"
                  [panelOpen]="panelOpenStatus.iban"
                  (opened)="handleOpenPanel('iban')"
                  (closed)="handleClosePanel('iban')"
                >
                  <div content>
                    <app-iban [isSummary]="true"></app-iban>
                  </div>
                </app-expansion-container>
              </div>

              <div *ngSwitchCase="'/channel'">
                <h2 *ngIf="question.blockTitle" class="block-title">
                  {{ question.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="'summary.other.channel' | translate"
                  [panelTitle]="applicationService.customerSource"
                  [panelOpen]="panelOpenStatus.channel"
                  (opened)="handleOpenPanel('channel')"
                  (closed)="handleClosePanel('channel')"
                >
                  <div content>
                    <app-channel [isSummary]="true"></app-channel>
                  </div>
                </app-expansion-container>
              </div>

              <div *ngSwitchCase="'/big-purpose'">
                <h2 *ngIf="question.blockTitle" class="block-title">
                  {{ question.blockTitle | translate }}
                </h2>
                <app-expansion-container
                  [panelHeader]="
                    (applicationService.reasonDescription
                      ? 'summary.bigTicket.reasonDescriptionTitle'
                      : 'summary.bigTicket.reasonTitle'
                    ) | translate
                  "
                  [panelTitle]="
                    applicationService.reasonDescription
                      ? applicationService.reasonDescription
                      : applicationService.reason
                  "
                  [panelOpen]="panelOpenStatus.bigPurpose"
                  (opened)="handleOpenPanel('bigPurpose')"
                  (closed)="handleClosePanel('bigPurpose')"
                >
                  <div content>
                    <app-big-ticket-purpose
                      [isSummary]="true"
                    ></app-big-ticket-purpose>
                  </div>
                </app-expansion-container>
              </div>

              <div
                *ngSwitchCase="'/personal-contact'"
                style="padding-top: 16px"
              >
                <h2 *ngIf="question.blockTitle" class="block-title">
                  {{ question.blockTitle | translate }}
                </h2>
                <div content>
                  <app-personal-contact
                    [isSummary]="true"
                  ></app-personal-contact>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #loader>
          <ngx-skeleton-loader
            [count]="5"
            [theme]="{
              height: '70px',
              'margin-bottom': '20px',
              'margin-top': '20px',
              width: '100%',
              'margin-right': '8px',
              'border-radius': '20px'
            }"
          ></ngx-skeleton-loader>
        </ng-template>
      </div>
    </div>

    <div actions class="actions">
      <button (click)="handleButtonClick()" mat-flat-button color="primary">
        {{
          isMinasidor
            ? ("summary.buttonText.minasidorSubmit" | translate)
            : ("summary.buttonText.submit" | translate)
        }}
      </button>
    </div>
    <div right-content>
      <app-personal-info></app-personal-info>
    </div>
  </app-card>
</div>
